import {
  filesService
} from '../_services'


// importamos las traducciones para gestionar los avisos
import i18n from '../i18n.js';


const state = {
  files: null,
  fileLoading: false,
  status: null,
  error: null,
  docTypes: {
    data: null,
    loading: false,
    error: null
  },
  dogDocuments: null,
  fileDocument: null
}

const actions = {

  /* funcion para subir un archivo de un titulo de un perro */
  stUploadDogTiltleDoc({
    commit, dispatch
  }, fileData) {

    return new Promise((resolve, reject) => {

    });

  },

  uploadFile({
    state,
    commit,
    dispatch
  }, fileData) {

    commit('setFileData', fileData);

    if (state.files.file === null) {
      commit('uploadingFileKo', 'no se ha agregado ningun fichero');
      dispatch('notifier/error', i18n.t('notifier_added_doc_dog_error'), {
        root: true
      })

    } else {

      /*  dispatch('notifier/success', i18n.t('error_no_fichero'), {
         root: true
       }); */
      commit('statusLoading', true);

      filesService.uploadDogDoc(state.files.file, state.files.dogId, state.files.docType)
        .then(
          () => {
            commit('uploadingFileOk', true);
            dispatch('notifier/success', i18n.t('notifier_added_doc_dog_ok'), {
              root: true
            });
            dispatch('getDogDocuments', state.files.dogId);
          },
          error => {
            commit('uploadingFileKo', error);
            dispatch('notifier/error', error, {
              root: true
            })
          });
    }
  },

  getTypeDocListp({
    commit
  }) {
    commit('statusLoading', true);
    setTimeout(() => {

      console.log("esto es una prueba");
      commit('statusLoading', false);

    }, 3000);
  },

  getTypeDocList({
    commit
  }) {

    return new Promise((resolve, reject) => {
      commit('getTypeDocListReq', true);
      filesService.getTypesDocList()
        .then(
          data => {            
            commit('getTypeDocListOk', data);
            resolve(data);
          },
          error => {
            commit('getTypeDocListKo', error);
            reject(error);
          })
    });
   
  },

  getDogDocuments({
    commit
  }, dogId) {

    commit('statusLoading', true);
    filesService.getDogDocuments(dogId)
      .then(
        data => {
          commit('getDogDocumentsOk', data);
        },
        error => {
          commit('getDogDocumentsKo', error);
        })
  },

  getOneDocument({
    commit
  }, docId) {
    commit('statusLoading', true);

    filesService.getOneDocument(docId)
      .then(
        data => {
          commit('getOneDocumentOk', data);
        },
        error => {
          commit('getOneDocumentKo', error);
        })

  },

  deleteDataDoc({
    commit
  }) {
    commit('deleteStoreData');
  }



}

const mutations = {

  statusLoading(state, status) {
    state.fileLoading = status;
  },

  uploadingFileOk(state, status) {
    state.fileLoading = false;
    state.error = null;
  },

  uploadingFileKo(state, error) {
    state.error = error;
    state.fileLoading = false;
  },

  setFileData(state, fileData) {
    state.files = fileData;

  },

  getTypeDocListReq(state, status) {
    state.docTypes.loading = status;
  },

  getTypeDocListOk(state, data) {    
    state.docTypes.data = data.data;
    state.docTypes.loading = false;
  },

  getTypeDocListKo(state, error) {
    state.error = error;
    state.docTypes.data = null;
    state.docTypes.loading = false;
  },

  getDogDocumentsOk(state, data) {
    state.dogDocuments = data;
    state.fileLoading = false;
  },

  getDogDocumentsKo(state, error) {
    state.error = error;
    state.dogDocuments = null;
    state.fileLoading = false;
  },

  getOneDocumentOk(state, data) {
    state.fileDocument = data;
    state.fileLoading = false;
  },

  getOneDocumentKo(state, error) {
    state.error = error;
    state.fileDocument = null;
    state.fileLoading = false;
  },

  deleteStoreData(state) {

    state.files = null;
    state.fileLoading = false;
    state.error = null;
    state.dogDocuments = null;
    state.fileDocument = null;

  }

}

const getters = {

  getTipoFiles(state) {
    //convertimos el obj en un array
    return Object.values(state.docTypes.data);
  }

}

export const files = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}